var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topTab',{ref:"topTab",attrs:{"tabData":_vm.tabData},on:{"tabChange":_vm.changePages}},[_c('tableList',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab === '1'),expression:"activeTab === '1'"}],on:{"clickCard":_vm.clickCard}}),(_vm.activeTab === '2')?_c('notificationInfo',{attrs:{"param":_vm.param}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }